import React, { useState } from 'react';

import { ContactUrl } from './ArticleSideNavigation';
import { ViewState } from './CustomerService';
import { CustomerServiceContext, defaultCustomerServiceContextState as defaultValues } from './CustomerServiceContext';

export interface CustomerServiceContextProviderProps {}

const CustomerServiceContextProvider: React.FC<CustomerServiceContextProviderProps> = ({ children }) => {
    const [view, setView] = useState<ViewState>(defaultValues.view);
    const [urlName, setUrlName] = useState(defaultValues.urlName);
    const [contact, setContact] = useState<ContactUrl | null>(defaultValues.contact);
    const [searchTerm, setSearchTerm] = useState(defaultValues.searchTerm);

    return (
        <CustomerServiceContext.Provider
            value={{
                view,
                urlName,
                contact,
                searchTerm,
                setView,
                setUrlName,
                setContact,
                setSearchTerm,
            }}
        >
            {children}
        </CustomerServiceContext.Provider>
    );
};

export default CustomerServiceContextProvider;
